import { useTranslation } from "react-i18next";
import { DeleteOutlined, DownOutlined, EditOutlined, EyeOutlined, MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, message, Modal, Radio, RadioChangeEvent, TableColumnsType, Typography } from 'antd';
import { TableProps } from 'antd/lib';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TableData from '../../../../components/table-data/TableData';
import { getReviewAndDiscussionByCourse, removeFeedback } from '../../../../service/course-management';
import { CourseManagementStore } from '../../../../stores/stores';
import { ReviewTpe } from '../../../../types/course-management';
import "./ReviewCourse.scss";
import ReplyModal from './feedback-modal/FeedbackModal';
import FormFilter from './filter-table/FormFilter';

type Props = {}
interface FilterDataType {
	stars?: number[];
	student?: string;
	status?: number;
	timeCreated?: any;
}
const ReviewCourse = (props: Props) => {
  const { t } = useTranslation();
	const { courseId } = useParams();
	const { showFilter, setShowFilter, reloadFeedback, setReloadFeedback } = CourseManagementStore()

	const [loading, setLoading] = useState<boolean>(false);
	const [pageNumber, setPageNumber] = useState<number>(1);
	const [pageSize, setPageSize] = useState<number>(10);
	const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
	const [statusOrder, setStatusOrder] = useState<string>("");
	const [courseStudentList, setCourseStudentList] = useState<any>([]);
	const [totalRecords, setTotalRecords] = useState<number>(0);
	const [isOpenReviewModal, setIsOpenReviewModal] = useState<boolean>(false)
	const [filterData, setFilterData] = useState<FilterDataType>({
		stars: [],
		student: '',
		status: undefined,
		timeCreated: undefined,
	});
	const [replyType, setReplyType] = useState<string>("feedback")

	const [reviewDetails, setReviewDetails] = useState<ReviewTpe>()
	const [isVisible, setIsVisible] = useState("1");
	const handleTableChange: TableProps["onChange"] = (
		pagination,
		filters,
		sorter: any
	) => {
		const data =
			sorter.order === "ascend"
				? "asc"
				: sorter.order === "descend"
					? "desc"
					: "";
		setStatusOrder(data);
		setFieldSortOrder(sorter.field);
	};

	const getOptionsDropdownMenu = (record: any): MenuProps["items"] => [
		{
			key: "feedback",
			label: t("Phản hồi", "Phản hồi"),
			icon: <EditOutlined />,
			disabled: record?.feedback?.length > 0,
		},
		{
			key: "view",
			label: t("Xem đánh giá", "Xem đánh giá"),
			icon: <EyeOutlined />,
		},
		{
			key: "delete",
			label: t("Gỡ đánh giá", "Gỡ đánh giá"),
			icon: <DeleteOutlined />,
			className: "dropdown-delete",
			danger: true,
		},
	];


	const dataColumns: TableColumnsType<any> = [
		{
			title: t("Số thứ tự", "Số thứ tự"),
			dataIndex: "numericalOrder",
			key: "numericalOrder",
			width: "50px    ",
			render: (_: any, record, index: number) => {
				return <div>{record?.numericalOrder}</div>;
			},
		},
		{
			title: t("Tên học viên", "Tên học viên"),
			dataIndex: "username",
			key: "username",
			sorter: true,
		},
		{
			title: t("Sao", "Sao"),
			dataIndex: "star",
			key: "star",
		},
		{
			title: t("Đánh giá", "Đánh giá"),
			dataIndex: "comment",
			key: "comment",

		},
		{
			title: t("Thời gian tạo", "Thời gian tạo"),
			dataIndex: "createdDate",
			key: "createdDate",
			sorter: true,
			render: (_: any, record) => {
				return (
					<span>
						{record?.createdDate
							? <p>{dayjs(record?.createdDate).format("DD/MM/YYYY")} {dayjs(record?.createdDate).format("HH:mm")}</p>
							: null}
					</span>
				);
			},
		},
		{
			title: "",
			dataIndex: "action",
			key: "action",
			width: "120px",
			render: (_: any, record) => {
				return (
					<>
						{isVisible === "1" ?
							<Dropdown
								menu={{
									items: getOptionsDropdownMenu(record),
									onClick: ({ key }) => {
										if (key === "feedback") {
											setIsOpenReviewModal(true)
											setReviewDetails(record)
											setReplyType("feedback")
										}
										if (key === "delete") {
											Modal.confirm({
												title: `Gỡ đánh giá của ${record?.username}`,
												content:
													t("Bạn có chắc chắn muốn gỡ đánh giá này!", "Bạn có chắc chắn muốn gỡ đánh giá này!"),
												okText: t("Xác nhận", "Xác nhận"),
												centered: true,
												cancelText: t("Huỷ", "Huỷ"),
												onOk: () => {
													handleRemoveFeedback(record?.id)
												},
												onCancel() {
												},
											})
										}
										if (key === "view") {
											setReplyType("view")
											setIsOpenReviewModal(true)
											setReviewDetails(record)
										}
									},
								}}
								placement="bottomRight"
							>
								<Button>
									<MoreOutlined />
								</Button>
							</Dropdown> : <Button icon={<EditOutlined />}
								onClick={() => {
									setIsOpenReviewModal(true)
									setReviewDetails(record)
								}}
							>{t("Phản hồi", "Phản hồi")}</Button>
						}
					</>

				);
			},
			fixed: "right",
		},
	];

	const getListData = async () => {
		setLoading(true);
		try {
			const payload = {
				page: pageNumber,
				size: pageSize,
				sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
				keyword: filterData?.student || undefined,
				courseId: Number(courseId),
				stars: filterData?.stars || [],
				status: isVisible,
				isFeedback: filterData?.status || undefined,
				createdDateFrom: !isEmpty(filterData?.timeCreated)
					? dayjs(filterData?.timeCreated?.[0])
						.toISOString()
					: undefined,
				createdDateTo: !isEmpty(filterData?.timeCreated)
					? dayjs(filterData?.timeCreated?.[1])
						.toISOString()
					: undefined,
			};
			const res = await getReviewAndDiscussionByCourse(payload)
			const { data } = res.data;

			setCourseStudentList(data.comments);
			setTotalRecords(data.count);
			setTimeout(() => {
				setLoading(false);
			}, 500);
		} catch (error) {

		}
		finally {
			setLoading(false);
		}

	};

	useEffect(() => {
		getListData()
	}, [isVisible, filterData, pageSize, pageNumber, reloadFeedback])

	const handleCloseFilter = () => {
		setShowFilter(false);
	};

	const handleOpenFilter = () => {
		setShowFilter(!showFilter);
	};

	const handleModeChange = (e: RadioChangeEvent) => {
		setIsVisible(e.target.value);
	};

	const handleRemoveFeedback = async (id: number) => {

		try {
			await removeFeedback(Number(id))
			message.success(t("Gỡ đánh giá thành công", "Gỡ đánh giá thành công"))
			setReloadFeedback(!reloadFeedback)
		} catch (error) {

		}
	}

	return (
		<div className='review-course'>
			<div className='review-course-mode'>
				<Radio.Group onChange={handleModeChange} value={isVisible}>
					<Radio.Button value="1">{t("Đang hiển thị", "Đang hiển thị")}</Radio.Button>
					<Radio.Button value="0">{t("Đã gỡ", "Đã gỡ")}</Radio.Button>
				</Radio.Group>
				<Button className="filter-button" onClick={handleOpenFilter}>
					<Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
					<DownOutlined />
				</Button>
			</div>

			{showFilter ? (
				<div className="form-filter">
					<FormFilter
						handleCloseFilter={handleCloseFilter}
						showFilter={showFilter}
						setFilterData={setFilterData}
					/>
				</div>

			) : null}

			<TableData
				dataColumns={dataColumns}
				loadingTable={loading}
				dataTable={courseStudentList}
				pageSize={pageSize}
				pageNumber={pageNumber}
				setPageNumber={setPageNumber}
				setPageSize={setPageSize}
				totalRecords={totalRecords}
				scroll={{ x: 1500, y: 800 }}
				pagination={true}
				hideSelection={false}
				handleTableChangeProps={handleTableChange}
			/>

			<ReplyModal
				open={isOpenReviewModal}
				reviewDetails={reviewDetails}
				handleCancel={() => setIsOpenReviewModal(false)}
				replyType={replyType}
			/>
		</div>
	)
}

export default ReviewCourse